(function () {
  'use strict';

  const MONTHLY_TEXT = 'Monatliche Lieferung';

  function getSubscriptionSelect() {
    return Array.from(document.querySelectorAll('select')).find(select =>
      Array.from(select.options).some(
        option => option.textContent.trim() === MONTHLY_TEXT
      )
    );
  }

  function fix() {
    const select = getSubscriptionSelect();

    // Subscription selector hasn't been loaded yet
    if (!select) {
      return;
    }

    // Only modify the text when "Monatliche Lieferung" is selected
    const selectedOption = select.options[select.selectedIndex];

    if (
      !selectedOption ||
      selectedOption.textContent.trim() !== MONTHLY_TEXT
    ) {
      return;
    }

    document
      .querySelectorAll(
        '[data-essential-upsell-element="subscription-offer"] *'
      )
      .forEach(el => {
        if (
          el.children.length === 0 &&
          el.textContent.trim() === 'Rabatt auf jede Lieferung'
        ) {
          el.textContent = '0% Rabatt auf jede Lieferung';
        }
      });
  }

  // Initial attempt
  fix();

  // Catch subscription widget being loaded/re-rendered
  const observer = new MutationObserver(() => {
    fix();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Catch changes to the subscription option
  document.addEventListener('change', function (event) {
    if (event.target.matches('select')) {
      fix();
    }
  });

})();